// @flow
import React from "react";

export function GraphqlLineBreak(val: string, isBrBreak?: boolean): string {
  // fix graphql multiple string bug
  return val.replace(/\n\r?/g, isBrBreak ? "<br/>" : "/n");
}

export function RemoveAllSpace(val: string): string {
  // fix graphql multiple string bug
  return val.replace(/ /g, "");
}

export function GetNotesFirstLine(val: string): string {
  return val.split("/n")[0];
}

export function TextareaMultilLines(val: string): string {
  let rs = "";
  val.split("/n").forEach((item: string, i: number) => {
    if (i === val.split("/n").length - 1) {
      rs += item;
    } else {
      rs += item + "\n";
    }
  });
  return rs;
}

export function utf8OutRangeFilter(unicodeString: string): string {
  const utf8String = unicodeString
    .replace(
      /[\u0080-\u07ff]/g, // U+0080 - U+07FF => 2 bytes 110yyyyy, 10zzzzzz
      "##"
    )
    .replace(
      /[\u0800-\uffff]/g, // U+0800 - U+FFFF => 3 bytes 1110xxxx, 10yyyyyy, 10zzzzzz
      "##"
    );
  return utf8String;
}
